/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { AdminControl, AdminControlInterface } from "../AdminControl";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "bool",
        name: "add",
        type: "bool",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b50336000908152602081905260408120805460ff191660011790556101fe90819061003b90396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c806324d7806c1461003b5780634b0bddd214610062575b600080fd5b61004e61004936600461016a565b610077565b604051901515815260200160405180910390f35b61007561007036600461018c565b61009a565b005b6001600160a01b031660009081526020819052604090205460ff16151560011490565b6100a333610077565b6100ff5760405162461bcd60e51b8152602060048201526024808201527f41646d696e436f6e74726f6c3a2063616c6c6572206973206e6f7420616e20616044820152633236b4b760e11b606482015260840160405180910390fd5b801561012c576001600160a01b0382166000908152602081905260409020805460ff191660011790555050565b506001600160a01b03166000908152602081905260409020805460ff19169055565b80356001600160a01b038116811461016557600080fd5b919050565b60006020828403121561017c57600080fd5b6101858261014e565b9392505050565b6000806040838503121561019f57600080fd5b6101a88361014e565b9150602083013580151581146101bd57600080fd5b80915050925092905056fea264697066735822122096169f7be40713e8f5ed29acd224d9adec59242e4ecf4fb0a4f1a65f5e490b3564736f6c63430008090033";

type AdminControlConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: AdminControlConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class AdminControl__factory extends ContractFactory {
  constructor(...args: AdminControlConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<AdminControl> {
    return super.deploy(overrides || {}) as Promise<AdminControl>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): AdminControl {
    return super.attach(address) as AdminControl;
  }
  connect(signer: Signer): AdminControl__factory {
    return super.connect(signer) as AdminControl__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): AdminControlInterface {
    return new utils.Interface(_abi) as AdminControlInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): AdminControl {
    return new Contract(address, _abi, signerOrProvider) as AdminControl;
  }
}
